<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"

const props = defineProps<{
  class?: HTMLAttributes["class"]
  orientation?: "horizontal" | "vertical" | "responsive"
}>()
</script>

<template>
  <div
    role="group"
    data-slot="field"
    :data-orientation="orientation"
    :class="cn(
      'space-y-2',
      orientation === 'horizontal' ? 'grid grid-cols-[var(--label-w,8rem)_1fr] items-start gap-2' : '',
      props.class,
    )"
  >
    <slot />
  </div>
</template>
